import {sendUserMessage} from '@/services/webhook/webhook'
import AppWarn from '@/services/errors/app-warns'
import { status } from '@/services/constants'
import { requestFormatter } from '@/services/utils'

export default {
  updateSchemaFormLabels({ commit }, data) {
    commit('UPDATE_SCHEMA_FORM_LABELS', data)
  },
  
  updateFormControlsButtonState({ commit }, data) {
    commit('UPDATE_FORM_CONTROLS_BUTTON_STATE', data)
  },

  updateFormControlsClicked({ commit }, data) {
    commit('FORM_CONTROLS_CLICKED_MESSAGE_ID')
    commit('FORM_CONTROLS_CLICKED', data)
  },
  
  updateShowFormControls ({ commit }, data) {
    commit('SHOW_FORM_CONTROLS', data)
  },

  updateFormStatus({ commit }, data) {
    commit('UPDATE_FORM_STATUS', data)
  },

  updateLastPendingFormStatus({rootState}) {
    const chats = rootState.chats
    const length = chats.length
    const formTypes = ['EmbeddedForm', 'SchemaForm', 'HumanHandoffForm']
    const possibleFormBlock = chats[length-2]
    const possibleFormBlockMessagesLength = possibleFormBlock?.messages?.length
    if(!possibleFormBlockMessagesLength) return
    const formType = possibleFormBlock?.messages[possibleFormBlockMessagesLength - 1]?.type
    const isStatusPresent = possibleFormBlock?.messages[possibleFormBlockMessagesLength - 1]?.messageValue?.status
    const isFormPending = isStatusPresent && possibleFormBlock.messages[possibleFormBlockMessagesLength - 1].messageValue.status[0] === status.PENDING

    if(possibleFormBlockMessagesLength >= 2 && 
      formTypes.includes(formType) && 
      isFormPending) 
      {
        possibleFormBlock.messages[possibleFormBlockMessagesLength -1 ].messageValue.status[0] = status.SUBMITTED
      }
  },
  
  updateCurrentScopedFormID({commit}, data) {
    commit('UPDATE_CURRENT_SCOPED_FORM_ID', data)
  },
  
  async FormControlActions({rootState}, data) {
    const requestBody = requestFormatter(rootState, data)
    try {
      await sendUserMessage({botRefId : rootState.botRefId, requestBody})
    } catch (error) {
      throw new AppWarn({
        message: 'Error sending form response',
        err: error
      })
    }
  }
}
